import { ComponentType } from '@angular/cdk/portal';
import { Injectable, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { NavigationStart, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { ReadOnlyInfoDialogComponent } from '../components/read-only-info-dialog/read-only-info-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  public navigation: Observable<any>;

  constructor(private dialog: MatDialog, private router: Router) {
    this.navigation = this.router.events
      .pipe(filter((event) => event instanceof NavigationStart));
  }

  public open<T, D = any, R = any>(
    componentOrTemplateRef: ComponentType<T> | TemplateRef<T>,
    config?: MatDialogConfig<D>,
  ): MatDialogRef<T, R> {
    const dialogRef: MatDialogRef<T> = this.dialog.open(componentOrTemplateRef, {
      closeOnNavigation: true,
      disableClose: true,
      ...config,
    });
    this.navigation
      .pipe(
        takeUntil(dialogRef.afterClosed()),
        tap(() => dialogRef.close()),
      )
      .subscribe();

    return dialogRef;
  }

  public openReadOnlyInfoDialog(): void {
    this.dialog.open(ReadOnlyInfoDialogComponent, {
      closeOnNavigation: true,
      disableClose: true,
      maxWidth: 360,
    });
  }
}
